import { Placeholder } from '@sitecore-jss/sitecore-jss-nextjs';
import { IconCtaColoredBoxProps } from '@ahc-digital/component-library';
import { ICON_CTA_COLORED_BOX_CARDS } from 'src/shared/static';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';
import { getDroplink } from 'src/shared/param-utils';
import { C32IconCTAColoredBoxProps } from './C32IconCTAColoredBox.types';

export function CreateIconCTAColoredBoxModel(props?: C32IconCTAColoredBoxProps) {
  type t = IconCtaColoredBoxProps;
  const { rendering, params, fields } = props || {};
  const { renderRichText, renderText } = useConditionalRendering();
  return {
    headline: renderText(fields?.Headline) as t['headline'],
    supportCopy: renderRichText(fields?.SupportCopy) as t['supportCopy'],
    supportCopyBottom: renderRichText(fields?.SupportCopyBottom) as t['supportCopyBottom'],
    headlineTag: getDroplink<t['headlineTag']>(params?.HeadlineTag, 'p'),
    columns: getDroplink<t['columns']>(params?.NumberOfColumns, '2'),
    supportCopyAlignment: getDroplink<t['supportCopyAlignment']>(
      params?.SupportCopyAlignment,
      'center'
    ),
    headlineAlignment: getDroplink<t['headlineAlignment']>(params?.HeadlineAlignment, 'center'),
    children: rendering && <Placeholder name={ICON_CTA_COLORED_BOX_CARDS} rendering={rendering} />,
  };
}
